// extracted by mini-css-extract-plugin
module.exports = {"root":"Tab_root__G_JOB","title":"Tab_title__ItLog","icon":"Tab_icon__wUAfk"};